﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { ValueSpan } from "./ValueSpan";

export class Risers implements ISiteObservationsPage {

    public id: string = 'risers';
    public label: string = 'Risers';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;

    public notifyResize() {
    }

    public show(station: ParameterSchemaStation): boolean {
        return station.Station.Id == "Malikai";
    }

    constructor(public mainSite: MainSite, private ctx: ILiveDataListenerContext) {
    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;
        var page = $('<div></div>');

        let mainDiv = $('<div></div>').appendTo(page);
        let t1Container = $('<div style="display: inline-block; margin-right: 1em; margin-bottom: 1em; vertical-align: top; border: 1px solid #e6e6e6"></div>')
            .appendTo(mainDiv);
        let t2Container = $('<div style="display: inline-block; margin-bottom: 1em; vertical-align: top; border: 1px solid #e6e6e6"></div>')
            .appendTo(mainDiv);

        let t3Container = $('<div></div>').appendTo(page);

        this.renderRiserTable(t1Container, listeners, station);
        this.renderMotionParamsTable1(t2Container, listeners, station);
        this.renderMotionParamsTable2(t3Container, listeners, station);

        page.appendTo(container);
    }

    renderMotionParamsTable1(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation) {
        let table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"></table>')
            .appendTo(container);

        let tbody = $('<tbody></tbody>').appendTo(table);
        let thead = $('<thead></thead>')
            .append($('<tr></tr>')
                .append($('<th>Motion Parameters</th>'))
                .append($('<th>MIS/MAS Reading</th>')))
            //.append($('<tr class="midi_tablePage_main_table_units"><th>&nbsp;</th><th></th></tr>'))
            .appendTo(table);

        let pgis = [
            ParameterGroupInfoSet.Vessel_Latitude_deg,
            ParameterGroupInfoSet.Vessel_Longitude_deg,
            ParameterGroupInfoSet.Heading_deg,
            ParameterGroupInfoSet.Pitch_deg,
            ParameterGroupInfoSet.Roll_deg,
            ParameterGroupInfoSet.SurgeAcceleration_mps2,
            ParameterGroupInfoSet.SwayAcceleration_mps2,
            ParameterGroupInfoSet.Heave_m,
        ]

        pgis.forEach((pgi, i) => {
            let row = $('<tr></tr>').appendTo(tbody);
            row.append($('<th></th>').text(pgi.ShortName + " (" + pgi.Units + ")"));

            let cell = $('<td></td>').appendTo(row);
            listeners.push(new ValueSpan(
                this,
                cell,
                new DefaultGroupFormatter(pgi),
                this.ctx
            ));
            tbody.append(row);
        });
    }

    renderMotionParamsTable2(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation) {
        let table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"></table>')
            .appendTo(container);
        
        let thr = $('<tr></tr>')
            .appendTo($('<thead></thead>')
                .appendTo(table))
            .append($('<th>Motion Parameters</th>'));
        
        let tbr = $('<tr></tr>')
            .appendTo($('<tbody></tbody>')
                .appendTo(table))
            .append($('<th>MIS/MAS Reading</th>'));


        thr.append($('<th></th>').text("North Draft (" + ParameterGroupInfoSet.Draft_m.Units + ")"));
        let cell = $('<td></td>').appendTo(tbr);
        listeners.push(new ValueSpan(
            this,
            cell,
            new DefaultGroupFormatter(ParameterGroupInfoSet.Draft_m, "Air Gap North"),
            this.ctx
        ));

        thr.append($('<th></th>').text("East Draft (" + ParameterGroupInfoSet.Draft_m.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new ValueSpan(
            this,
            cell,
            new DefaultGroupFormatter(ParameterGroupInfoSet.Draft_m, "Air Gap East"),
            this.ctx
        ));

        thr.append($('<th></th>').text("South Draft (" + ParameterGroupInfoSet.Draft_m.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new ValueSpan(
            this,
            cell,
            new DefaultGroupFormatter(ParameterGroupInfoSet.Draft_m, "Air Gap South"),
            this.ctx
        ));

        thr.append($('<th></th>').text("West Draft (" + ParameterGroupInfoSet.Draft_m.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new ValueSpan(
            this,
            cell,
            new DefaultGroupFormatter(ParameterGroupInfoSet.Draft_m, "Air Gap West"),
            this.ctx
        ));

        thr.append($('<th></th>').text(ParameterGroupInfoSet.InclinationEW_deg.ShortName + " (" + ParameterGroupInfoSet.InclinationEW_deg.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new ValueSpan(
            this,
            cell,
            new DefaultGroupFormatter(ParameterGroupInfoSet.InclinationEW_deg),
            this.ctx
        ));

        thr.append($('<th></th>').text(ParameterGroupInfoSet.InclinationNS_deg.ShortName + " (" + ParameterGroupInfoSet.InclinationNS_deg.Units + ")"));
        cell = $('<td></td>').appendTo(tbr);
        listeners.push(new ValueSpan(
            this,
            cell,
            new DefaultGroupFormatter(ParameterGroupInfoSet.InclinationNS_deg),
            this.ctx
        ));
    }

    renderRiserTable(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation) {
        let table = $('<table class="table table-striped table-hover midi_tablePage_main_table midi_common_table"></table>')
            .appendTo(container);

        let tbody = $('<tbody></tbody>').appendTo(table);
        let thead = $('<thead></thead>').appendTo(table);

        let pgis = [
            ParameterGroupInfoSet.RiserTension_kN,
            ParameterGroupInfoSet.RiserTensionerPressure1_psi,
            ParameterGroupInfoSet.RiserTensionerPressure2_psi,
            ParameterGroupInfoSet.RiserTensionerPressure3_psi,
            ParameterGroupInfoSet.RiserTensionerPressure4_psi
        ]

        let mainHead = $('<tr class="midi_tablePage_main_table_header"></tr>')
            .append($('<th>Sensor</th>'))
            .appendTo(thead);

        let unitsHead = $('<tr class="midi_tablePage_main_table_units"></tr>')
            .append($('<th></th>'))
            .appendTo(thead);

        pgis.forEach(pgi => {
            mainHead.append($('<th></th>').text(pgi.ShortName));
            unitsHead.append($('<th></th>').text(pgi.Units));
        });

        //hard code order for Malikai
        let sensorIds = [
            "Riser 15",
            "Riser 22",
            "Riser 13",
            "Riser 20",
            "Riser 7",
            "Riser 4",
            "Riser 24",
            "Riser 12",
            "Riser 23",
            "Riser 21",
            "Riser 16",
            "Riser 3",
            "Riser 6",
            "Riser 8",
            "Riser 11",
            "Riser 18",
            "Riser 19"
        ]

        sensorIds.forEach((sensorId) => {
            let row = $('<tr></tr>');

            if (sensorId.indexOf("Riser ") !== -1) {
                row.append($('<th></th>').text(sensorId));
                pgis.forEach((pgi, i) => {
                    let cell = $('<td></td>').appendTo(row);

                    listeners.push(new ValueSpan(
                        this,
                        cell,
                        new DefaultGroupFormatter(pgi, sensorId),
                        this.ctx
                    ));
                    tbody.append(row);
                });
            }
        });

    }
}